// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".box-info-countdown[data-v-1c144ee6]{right:0;top:-130px;background:#00c300}.box-info-countdown[data-v-1c144ee6]::after{right:5px;bottom:-16px;border-color:#00c300 rgba(0,0,0,0) rgba(0,0,0,0) rgba(0,0,0,0)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
